module.exports = __webpack_public_path__ + "img/i-lingerie-black.d1418ecf.svg";